import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { AnalysisState, AnalysisStateData } from 'src/app/shared/interface/analysis';
import * as fromAnalysis from './analysis.reducer';

export const reducers: ActionReducerMap<AnalysisState> = {
  data: fromAnalysis.reducer,
};

export const getAnalysisItem = createFeatureSelector<AnalysisStateData>(
  'Analysis'
);
